// removed by extract-text-webpack-plugin
module.exports = {"main":"src-pages-over----index-module---main---3bRFd src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","imageContainer":"src-pages-over----index-module---imageContainer---2DqC_","image":"src-pages-over----index-module---image---2d2m2","content":"src-pages-over----index-module---content---2qAik","title":"src-pages-over----index-module---title---2cbZi","text":"src-pages-over----index-module---text---3ntT0","link":"src-pages-over----index-module---link---17mVz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/over/index.module.css
// module id = 316
// module chunks = 174340286061159